module.exports = __webpack_public_path__ + "img/left-3.1ae738c1.jpg";